import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { ColorCategoryActions, ColorCategoryStore, STATUS } from 'Stores/colorCategoryStore'
import ColorCategoryForm from 'Modules/colorCategory/colorCategoryForm'

export default class ColorCategoryCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [ColorCategoryStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    ColorCategoryActions.createEmptyColorCategory()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('ColorCategory Created', {
        autoClose: 3000,
        onClose: () => {
          ColorCategoryActions.clearFormToast()
        }
      })
      ColorCategoryActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('ColorCategory Create Failed', {
        autoClose: 3000,
        onClose: () => {
          ColorCategoryActions.clearFormToast()
        }
      })
      ColorCategoryActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <ColorCategoryForm />
      </React.Fragment>
    )
  }
}
